import { Button, Grid } from '@mui/material';
import { forwardRef, Fragment, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import alertify from 'alertifyjs';
import { GeopostTextField } from 'fileIndexing/otherComponents/GeopostTextField';
import { GeopostDropdown } from 'fileIndexing/otherComponents/GeopostDropdown';
import { FormContainer } from 'react-hook-form-mui';

import { ITag } from '../interfaces/ITag';
import { useSaveTag } from '../useTags';

export const TagsForm = ({ setOpenModal, refetchTableData, setLoading, formData, tagGroupToken }: Props) => {
    const { control } = useForm<ITag>({ defaultValues: formData || undefined });

    const [data, setData] = useState<ITag | null>(null);

    const { data: saveTagGroupsData, isLoading } = useSaveTag(data);

    const handleData = (data: ITag) => {
        let newData = data;
        if (formData) {
            newData.Token = formData.Token;
        }
        else {
            newData.Token = '';
        }

        newData.TagGroupToken = tagGroupToken;
        setData(newData);
    };

    // AVISO: talvez seja retirada essa parte
    function wait(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function executeSave(): Promise<void> {
        setOpenModal(false);
        setLoading(true);
        await wait(2000);
        setLoading(false);
        refetchTableData();
    }

    useEffect(() => {
        if (saveTagGroupsData) {
            if (saveTagGroupsData === 'Success') {
                executeSave();
            }
            else {
                alertify.notify('Ocorreu um erro criando uma nova Instituição');
            }
        }
    }, [saveTagGroupsData]);

    return (
        <Fragment>
            <FormContainer<ITag> defaultValues={formData ?? {}} onSuccess={(data) => handleData(data)} FormProps={{ style:{ width: '100%' } }}>
                <Grid spacing={2} container>
                    <Grid spacing={2} container item>
                        <Grid xs={12} item>
                            <GeopostTextField fieldName={'Name'} label={'Name'} />
                        </Grid>
                        <Grid xs={12} item>
                            <GeopostTextField fieldName={'Regex'} label={'Regex'} />
                        </Grid>
                    </Grid>
                    <Grid container item direction="row-reverse">
                        <Button variant='contained' color='primary' type='submit'>SAVE</Button>
                    </Grid>
                </Grid>
            </FormContainer>
        </Fragment >
    );
};

interface Props {
    setOpenModal: (value: boolean) => void;
    refetchTableData: () => void;
    setLoading: (value: boolean) => void;
    formData?: ITag | null;
    tagGroupToken: string;
}